// Queries
import manufacturerSearch from "./ManufacturerSearchQuery.gql";

export const Query = {
    manufacturerSearch,
};
